export const en = {
  dashboard: "Dashboard",
  statistics: "Statistics",
  resources: "Resource Management",
  users: "Users",
  setting: "Setting"
}
export const zh = {
  dashboard: "首页",
  statistics: "统计中心",
  resources: "资源管理",
  users: "用户中心",
  setting: "设置"
}



// WEBPACK FOOTER //
// ./src/i18n/module_lang/Menu_lang.js